import Web3 from "web3";
import { START_TUNNEL, axiosCert } from "../axios";
import useAuth from "../../utils/CustomHooks/useAuth/useAuth";

const web3address = "http://gate-atom.dltc.spbu.ru:1500";
/**
 * Hook that create trigger function that starts web3 tunnel
 * @returns {() => Promise<Web3 | undefined>}
 */

export function useStartWeb3Tunnel() {
  const { auth } = useAuth();

  return () =>
    axiosCert
      .get(START_TUNNEL, {
        params: {
          SubjKeyId: auth.user.cert,
        },
      })
      .then((res) => {
        console.log({
          res: res.data,
        });
        return new Web3(web3address);
      })
      .catch((error) => {
        console.log({
          error,
        });
        return undefined;
      });
}
